import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { shallowEqual } from 'react-redux';

import ListRow from './ListRow';

const styles = {
  tableBody: {
    height: 520,
    overflow: 'auto'
  }
};

class List extends Component {
  shouldComponentUpdate({ elems: newElems, ...nextProps }) {
    const { elems, ...props } = this.props;

    return !shallowEqual(props, nextProps)
      || JSON.stringify(elems) !== JSON.stringify(newElems);
  }

  render() {
    const {
      Row = ListRow,
      elems,
      classes,
      rowElem,
      currentRow,
      loading,
      ...props
    } = this.props;

    if (loading) {
      return (
        <TableBody className={classes.tableBody}>
          <TableRow>
            <TableCell colSpan={8}>
              <Typography variant="h6" align="center">
                Chargement...
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      );
    }

    if (elems.length) {
      return (
        <TableBody className={classes.tableBody}>
          {elems.map((elem) => (
            <Row
              {...props}
              rowElem={currentRow === elem._id ? rowElem : null}
              open={elem._id === currentRow}
              key={elem._id}
              elem={elem}
            />
          ))}
        </TableBody>
      );
    }

    return (
      <TableBody className={classes.tableBody}>
        <TableRow>
          <TableCell colSpan={8}>
            <Typography variant="h6" align="center">
              Aucune donnée trouvée
            </Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }
}

List.propTypes = {
  elems: PropTypes.array.isRequired,
  keys: PropTypes.array.isRequired,
  handlers: PropTypes.object
};

List.defaultProps = {
  elems: [],
  keys: [],
  handlers: {}
};

export default withStyles(List, styles);
